/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList } from '../../../../Fct/generics/FctParams';
import { FaLock } from 'react-icons/fa';
export var GetAssetsIn = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'GETTER',
    method: 'getAssetsIn',
    description: 'Get the list of markets an account is currently entered into',
    supportedContracts: [
        { chainId: 1, address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B' },
    ],
    getParams: function (_a) { return ({
        input: {
            to: new FctAddress({ destination: 'comptroller' }),
            methodParams: {
                account: new FctAddress({ isPreview: true, icon: FaLock }),
            },
        },
        output: {
            addresses: new FctAddressList({ innerIndex: 0, isPreview: true }),
        },
    }); },
});
